import moment from 'moment';

export default {
  validators: {
    TagRadio: (val) => new Promise((resolve, reject) => {
      try {
        if(!val.opValue){
          reject(new Error(`${val.labelName}不能为空`));
        } else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
    TagCheckbox: (val) => new Promise((resolve, reject) => {
      try {
        if(!val.opValue){
          reject(new Error(`${val.labelName}不能为空`));
        } else if (val.opValue.param_list[0].param_id.length===0) {
          reject(new Error(`${val.labelName}不能为空`));
        }else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
    TagSection: (val) => new Promise((resolve, reject) => {
      try {
        if(!val.opValue){
          reject(new Error(`${val.labelName}不能为空`));
        } else if(val.opType === 'RANGE'){
          if(!val.opValue.extra_map[0] || !val.opValue.extra_map[1]) {
            reject(new Error(`${val.labelName}不能为空`));
          } else if (val.opValue.extra_map[0] && val.opValue.extra_map[1] && (val.opValue.extra_map[1] < val.opValue.extra_map[0])) {
            reject(new Error(`${val.labelName}范围填写有误`));
          } else {
            resolve();
          }
        } else if (val.opType === 'RANGELT' || val.opType === 'RANGEGT') {
          if(!val.opValue.extra_map[0]){
            reject(new Error(`${val.labelName}不能为空`));
          } else {
            resolve();
          }
        }else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
    TagTime: (val) => new Promise((resolve, reject) => {
      try {
        if(!val.opValue){
          reject(new Error(`${val.labelName}不能为空`));
        } else if(val.opType ==='RANGE') {
          if(!val.opValue.extra_map[0] || !val.opValue.extra_map[1]) {
            reject(new Error(`${val.labelName}区间值不能为空`));
          } else if (val.opValue.extra_map[0] && val.opValue.extra_map[1] && moment(+val.opValue.extra_map[1]).isAfter(moment(+val.opValue.extra_map[0]).add(365,'days'))) {
            reject(new Error(`${val.labelName}区间值支持最多选择365天`));
          } else {
            resolve();
          }
        } else if (val.opType === 'RELRANGE') {
          if((+val.opValue.extra_map[0] !==0 && +val.opValue.extra_map[1] !==0) && (!+val.opValue.extra_map[0] || !+val.opValue.extra_map[1])) {
            reject(new Error(`${val.labelName}不能为空`));
          } else if(Math.abs(+val.opValue.extra_map[1])>Math.abs(+val.opValue.extra_map[0])) {
            reject(new Error(`请输入正确的${val.labelName}`));
          } else {
            resolve();
          }
        } else if(val.opType === "RANGEGT" || val.opType === "RANGELT") {
          if(!val.opValue.extra_map[0]) {
            reject(new Error(`${val.labelName}不能为空`));
          } else {
            resolve();
          }
        }else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
    TagSku: (val) => new Promise((resolve, reject) => {
      try {
        if(val.opValue && val.opValue.extra_map.length>300){
          reject(new Error(`${val.labelName}数量不能大于300`));
        }else {
          resolve();
        }

      } catch (error) {
        throw error;
      }
    }),
    TagRadioDouble: (val) => new Promise((resolve, reject) => {
      try {
        if(!val.opValue){
          reject(new Error(`${val.labelName}不能为空`));
        } else if (val.opValue.param_list[0].param_id.length === 0 || !val.opValue.param_list[0].param_id[0] ) {
          reject(new Error(`${val.labelName}不能为空`));
        }else if (val.opValue.param_list[0].subOpValue.param_id.length === 0 || !val.opValue.param_list[0].subOpValue.param_id[0] ) {
          reject(new Error(`${val.labelName}不能为空`));
        }else if (+val.opValue.param_list[0].subOpValue.param_id[0] !== 1 && val.opValue.param_list[0].subOpValue.extra_map.length === 0 ) {
          reject(new Error(`${val.labelName}不能为空`));
        }else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
  }
}
